export const mtzPlanSubscriptionEventPublish = (event) => ({
  type: "MTZ_PLAN_SUBSCRIPTION_PUBLISH",
  event,
});
